import styled from 'styled-components/native';

import { Refresh } from 'svg';

export default styled(Refresh)``;
